import { ReactNode } from 'react';

import { PaymentMethodV2 } from 'state/internal/getSubscriptionDetails/types';

import { isCreditCardExpired } from '../check/isCreditCardExpired';
import { iconCreditCard, iconCreditCardSquare, paymentTypeV2Check } from '../payment';

type PaymentDataOptions = Partial<{
  bulletsType: 'short' | 'long';
}>;

const SHORT_BULLETS = <>&bull;&bull;&bull;&bull;</>;
const LONG_BULLETS = (
  <>&bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull;</>
);

export const getPaymentMethodV2Data = (
  paymentMethod: PaymentMethodV2 | null,
  options?: PaymentDataOptions
) => {
  const expiring =
    !!paymentMethod?.expiry_year && !!paymentMethod?.expiry_month
      ? isCreditCardExpired(paymentMethod.expiry_year, paymentMethod.expiry_month)
      : false;

  let paymentType: string = 'card';
  let cardBrand = () =>
    paymentMethod && paymentMethod.is_valid ? iconCreditCard.CARDLOGO : iconCreditCard.MISSING;
  let cardNumString: string | ReactNode = '';
  let cardDate: string = '';
  let emailPaymentMethod: string | null = null;
  let brandText = '';

  /* const isVenmo =
    paymentMethod?.source === paymentTypeV2Schema.enum.braintree_venmo ||
    paymentMethod?.source === paymentTypeV2Schema.enum.braintree_card; */

  if (paymentMethod) {
    paymentType = paymentTypeV2Check(paymentMethod);
    const brand = paymentMethod?.brand;
    cardNumString = options?.bulletsType === 'short' ? SHORT_BULLETS : LONG_BULLETS;
    cardBrand = () => {
      /* if (paymentMethod.source === paymentTypeV2Schema.enum.stripe_sepa_direct_debit) {
        return iconCreditCard.SEPA;
      } */
      if (paymentType === 'card' && brand && typeof brand !== 'boolean') {
        return iconCreditCard[brand.toUpperCase()] || iconCreditCardSquare.CARDLOGO;
      }
      /* if (isVenmo) {
        return iconCreditCardSquare.VENMO;
      } */
      if (paymentType === 'paypal') {
        return iconCreditCardSquare.PAYPAL;
      }

      if (paymentType === 'shopPay') {
        return iconCreditCardSquare.SHOPPAY;
      }

      if (paymentType === 'applePay') {
        return iconCreditCardSquare.APPLEPAY;
      }

      return iconCreditCardSquare.CARDLOGO;
    };
  }

  if (
    paymentMethod &&
    // paymentMethod?.source === paymentTypeV2Schema.enum.stripe_sepa_direct_debit &&
    paymentMethod.bank_code &&
    paymentMethod.last_digits
  ) {
    cardNumString = (
      <>
        {paymentMethod.bank_code} &bull;&bull; {String(paymentMethod.last_digits).padStart(4, '0')}
      </>
    );
  } else if (
    paymentType === 'paypal' ||
    (paymentMethod && Object.prototype.hasOwnProperty.call(paymentMethod, 'paypal_account_email'))
  ) {
    cardNumString = paymentMethod?.paypal_account_email || '';
    emailPaymentMethod = paymentMethod?.paypal_account_email || '';
    /* } else if (isVenmo) {
    cardNumString = paymentMethod?.name || 'ㅤ'; */
  } else if (paymentMethod?.last_digits) {
    cardNumString = (
      <>
        {cardNumString} {String(paymentMethod.last_digits).padStart(4, '0')}
      </>
    );
  }

  if (paymentMethod && paymentMethod?.expiry_month && paymentMethod?.expiry_year) {
    const month = paymentMethod?.expiry_month;
    const year = paymentMethod?.expiry_year;
    const isDate = month && year;
    cardDate = isDate ? `${String(month).padStart(2, '0')}/${year}` : '';
  }

  if (paymentMethod && paymentMethod?.brand) {
    brandText = paymentMethod.brand;
  }

  /* if (paymentMethod?.source === paymentTypeV2Schema.enum.stripe_sepa_direct_debit) {
    brandText = sepaBrand;
  } */

  /* if (isVenmo) {
    // TODO: Need to verify how to add Venmo in paymentMethod.brand? Or other property?
    brandText = 'Venmo';
  } */

  return {
    type: paymentType,
    brandText,
    expiring,
    paymentType,
    cardBrand,
    cardNumString,
    cardDate,
    emailPaymentMethod
  };
};
